// Section 22 main-screen tabs. The shell renders `tabComponents[ui.tab]` with no props: every
// tab root reads the store itself (24.14). Stream F owns People, Jobs, Policies, History and the
// dev-only Debug tab; the other roots belong to their streams and are mounted here (M6):
//   rations -> RationsTab  from src/ui/rations/rations-tab.tsx  (stream A; the run's config)
//   build   -> BuildTab    from src/ui/build/build-tab.tsx      (stream B; includes Tools)
//   health  -> HealthTab   from src/ui/health/health-tab.tsx    (stream C)
//   society -> SocietyTab  from src/ui/society/society-tab.tsx  (stream D; E1's JusticePanel)
import type { ComponentType } from 'preact';
import { cfgOption, type Tab } from '../../store';
import { BuildTab } from '../build/build-tab';
import { HealthTab } from '../health/health-tab';
import { HistoryTab } from '../history/history-tab';
import { JobsTab } from '../jobs/jobs-tab';
import { PeopleTab } from '../people/people-tab';
import { PoliciesTab } from '../policies/policies-tab';
import { RationsTab } from '../rations/rations-tab';
import { JusticePanel } from '../society/justice/justice-panel';
import { SocietyTab } from '../society/society-tab';
import { DebugTab } from './debug-tab';

/** The Rations tab projects on the run's config (a save's snapshot, ADR-0008). */
function RationsSlot() {
  return <RationsTab {...cfgOption()} />;
}

/** The Society tab with Stream E1's justice panel in its `justice` slot. */
function SocietySlot() {
  return <SocietyTab justice={<JusticePanel />} />;
}

export const tabComponents: Record<Tab, ComponentType> = {
  people: PeopleTab,
  jobs: JobsTab,
  rations: RationsSlot,
  build: BuildTab,
  policies: PoliciesTab,
  society: SocietySlot,
  health: HealthTab,
  history: HistoryTab,
  debug: DebugTab,
};

/** Tabs in the tab bar, in Section 22 order. Debug appears only in development builds. */
export const TAB_ORDER: readonly Tab[] = [
  'people',
  'jobs',
  'rations',
  'build',
  'policies',
  'society',
  'health',
  'history',
  ...(import.meta.env.DEV ? (['debug'] as const) : []),
];
